/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { CLEAR_SYSTEM_HEALTH_INTERVAL, SET_SYSTEM_HEALTH_INTERVAL } from './healthstats.types';

export const setSystemHealthIntervalAction = (systemHealthInterval: any): AnyAction => ({
    type: SET_SYSTEM_HEALTH_INTERVAL,
    payload: {
        systemHealthInterval,
    },
});

export const clearSystemHealthIntervalAction = (): AnyAction => ({
    type: CLEAR_SYSTEM_HEALTH_INTERVAL,
    payload: {
        systemHealthInterval: null,
    },
});
